import { trace } from 'firebase/performance';
import { perf } from '../firebase';

const noop = { putAttribute: () => {}, stop: () => {} };

export function startTrace(name, attributes = {}) {
  if (!perf) return noop;
  const t = trace(perf, name);
  Object.entries(attributes).forEach(([k, v]) => t.putAttribute(k, String(v)));
  t.start();
  return t;
}
